<template>
  <div class="createaccount--role">
    <v-layout wrap row>
      <v-flex xs12>
        <p>Your role</p>
        <v-radio-group
          v-model="value.type"
          :disabled="disableInputs"
          @change="$emit('lookupUser')">
          <v-radio label="Buyer / Homeowner" value="CUSTOMER" />
          <v-radio label="Real Estate Agent" value="REAL_ESTATE_PROFESSIONAL" />
        </v-radio-group>
      </v-flex>

      <v-flex sm12>
        <TextInputCommon
          v-model="value.email"
          :disabled="disableInputs"
          :validations="{ ...inputValidations.email, required: true }"
          display-name="Email Address"
          identifier="email"
          @change="$emit('lookupUser')" />
      </v-flex>

      <v-flex v-if="hasExistingAccount" xs12>
        <BaseAlert
          :hg-value="true"
          hg-lead-in="Account Found"
          hg-type="info"
          ref="account-found-alert">
          <p>We found an existing account associated with your email address.</p>
          <p>
            <a class="content-link" @click="resetUser">Change Email</a>
            <router-link :to="signinLink" class="content-link">Sign In</router-link>
          </p>
        </BaseAlert>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { Components, Constants } from '@spectorasoftware/homegauge-vue';

import RouteNames from '@/router/constants/route-names';
import TextInputCommon from '@/components/common/TextInputCommon.vue';

const { BaseAlert } = Components;
const { InputValidations } = Constants;

export default {
  components: {
    BaseAlert,
    TextInputCommon,
  },
  inject: ['$validator'],
  props: {
    hasExistingAccount: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      required: true,
    },
  },
  computed: {
    disableInputs() {
      return this.loading || this.hasExistingAccount;
    },
    signinLink() {
      return { name: RouteNames.AppointmentSignIn };
    },
  },
  data() {
    return {
      inputValidations: InputValidations,
    };
  },
  methods: {
    resetUser() {
      this.$emit('resetUser');
    },
  },
};
</script>

<style lang="scss" scoped>
.content-link {
  margin: 0 5px;

  &:first-child {
    margin-left: 0;
  }

  &:last-child {
    margin-right: 0;
  }
}
</style>
